module.exports = __webpack_public_path__ + "static/media/DictatorRoleCard.cc231766.png";